import type { IconProps } from './types';

const SeparatorIcon = (props: IconProps) => {
  const { height = 50, width = 2, viewBox = '0 0 2 50' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
    >
      <path d="M1 1L1 49" stroke="#BEC4C8" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};

export default SeparatorIcon;
